import React from 'react';
import { InfinitySpin } from 'react-loader-spinner';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import legoLottie from '../../assets/homeLogo.lottie';

const Loader = ({ isVisible }) => {
  return (
    <div
      className={`
        fixed top-0 left-0 w-full h-screen
        flex justify-center items-center
        bg-white/50 backdrop-blur-md z-[10000]
        transition-opacity duration-400 ease-in-out
        ${isVisible ? 'opacity-100 visible' : 'opacity-0 invisible'}
      `}>
      {/* <InfinitySpin visible={true} width="250" color="#4367b0" ariaLabel="infinity-spin-loading" />
       */}
      <div>
        {/* <DotLottieReact
          src="https://lottie.host/682147e8-fad1-4a89-9c35-a6f580b48c57/XcUGwPXYaV.lottie"
          loop
          autoplay
        /> */}
        <DotLottieReact
          src="https://lottie.host/bb8b8131-471f-4686-b694-0a936eb9a72c/Qa0vb2R94l.lottie"
          loop
          autoplay
        />
      </div>
    </div>
  );
};

export default Loader;
